import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=315aedd0&"
import script from "./ResultsPage.vue?vue&type=script&lang=js&"
export * from "./ResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports